window.BTKSearchTypes = (function () {

  var CONTEXT_KEY = 'btk_kitchen_context';
  var projectProductsCache = {};

  // ── Context ───────────────────────────────────────────────────────────────

  // The variant a unit is shown at when the search named no size - the one
  // its page and the planner's Add Units start on (snippets/
  // btk-preferred-variant-id.liquid; Planner Bugs row 67): a [split] option
  // (Height / Depth) or a Height at its standard value (Medium / 570), a
  // Hinge at Right, anything else at its first value; else the first Medium.
  function preferredVariant(p) {
    var vs = (p && p.variants) || [];
    var opts = (p && p.options) || [];
    var want = [], hpos = 0;
    opts.forEach(function (o, i) {
      var name = String(typeof o === 'string' ? o : (o && o.name) || '').toLowerCase();
      var pos = (o && o.position) || (i + 1);
      var values = (o && o.values) || [];
      if (/height/.test(name)) hpos = pos;
      var t = values[0];
      if (/\[split\]/.test(name) || /height/.test(name)) {
        var std = values.find(function (v) { var h = String(v).trim().toLowerCase(); return h === '570' || h === 'medium'; });
        if (std) t = std;
      } else if (/hinge/.test(name)) {
        var r = values.find(function (v) { return /^right$/i.test(String(v).trim()); });
        if (r) t = r;
      }
      want[pos] = t;
    });
    var exact = vs.filter(function (v) {
      for (var pos = 1; pos <= opts.length; pos++) if (want[pos] != null && v['option' + pos] !== want[pos]) return false;
      return true;
    });
    var pick = exact.find(function (v) { return v.available !== false; }) || exact[0];
    if (pick) return pick;
    if (hpos) {
      var med = vs.filter(function (v) { return String(v['option' + hpos] || '').trim().toLowerCase() === 'medium'; });
      pick = med.find(function (v) { return v.available !== false; }) || med[0];
      if (pick) return pick;
    }
    return vs[0];
  }

  function prettifyHandle(handle) {
    if (!handle) return '';
    return handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function readContext() {
    try {
      var raw = sessionStorage.getItem(CONTEXT_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.style) return parsed;
      }
    } catch (e) {}
    return null;
  }

  function readContextFromCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = cart && cart.attributes ? cart.attributes : {};
        var style   = (a.kitchen_style || '').trim();
        var colour  = (a.kitchen_colour || '').trim();
        var carcase = (a.kitchen_carcase_colour || '').trim();
        if (!style) return null;
        var ctx = { style: style, colour: colour, carcase: carcase };
        try { sessionStorage.setItem(CONTEXT_KEY, JSON.stringify(ctx)); } catch (e) {}
        return ctx;
      })
      .catch(function () { return null; });
  }

  // ── Swatches ──────────────────────────────────────────────────────────────

  function getProjectSwatches() {
    var ctx = readContext();
    if (!ctx || !ctx.style) return null;
    var styleData = window.BTKStyleData || {};
    var styleMeta = styleData[ctx.style];
    if (!styleMeta) return null;

    var door = null;
    if (ctx.colour && styleMeta.doorSwatches && styleMeta.doorSwatches[ctx.colour]) {
      var ds = styleMeta.doorSwatches[ctx.colour];
      door = ds.swatch ? { type: 'image', value: ds.swatch }
           : ds.hex    ? { type: 'hex',   value: ds.hex }
           : null;
    }

    var carcase = null;
    if (ctx.carcase) {
      var cs = (window.BTKCarcaseSwatches || {})[ctx.carcase];
      if (cs) {
        carcase = cs.swatch ? { type: 'image', value: cs.swatch }
                : cs.hex    ? { type: 'hex',   value: cs.hex }
                : null;
      }
    }

    return (door || carcase) ? { door: door, carcase: carcase } : null;
  }

  // Builds a swatch layer element. doc is the owner document (DOMParser or live).
  function buildSwatchLayer(doc, swatch, size, top, left) {
    var d = doc.createElement('span');
    d.style.cssText = 'width:' + size + 'px;height:' + size + 'px;border-radius:2px;'
      + 'position:absolute;top:' + top + 'px;left:' + left + 'px;overflow:hidden;'
      + 'border:1px solid rgba(0,0,0,0.12);display:block;';
    if (swatch.type === 'image') {
      var img = doc.createElement('img');
      img.src = swatch.value;
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      img.alt = '';
      d.appendChild(img);
    } else {
      d.style.background = swatch.value;
    }
    return d;
  }

  // Builds a stacked swatch pair element sized for use in a tab button.
  function buildSwatchStack(doc, size) {
    var swatches = getProjectSwatches();
    if (!swatches) return null;

    var offX = Math.round(size * 0.45);
    var offY = Math.round(size * 0.3);

    var outer = doc.createElement('span');
    outer.setAttribute('aria-hidden', 'true');
    outer.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;'
      + 'background:#fff;border-radius:4px;padding:3px;'
      + 'border:1px solid rgba(0,0,0,0.12);'
      + 'flex-shrink:0;vertical-align:middle;margin-right:6px;';

    var wrap = doc.createElement('span');
    wrap.style.cssText = 'position:relative;display:inline-block;'
      + 'width:' + (size + offX) + 'px;height:' + (size + offY) + 'px;';

    if (swatches.carcase) wrap.appendChild(buildSwatchLayer(doc, swatches.carcase, size, 0, 0));
    if (swatches.door)    wrap.appendChild(buildSwatchLayer(doc, swatches.door, size, offY, offX));

    outer.appendChild(wrap);
    return outer;
  }

  // ── Product fetching & filtering ──────────────────────────────────────────

  function fetchProjectProducts(collectionHandle, callback) {
    if (projectProductsCache[collectionHandle]) {
      callback(projectProductsCache[collectionHandle]);
      return;
    }
    fetch('/collections/' + collectionHandle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        products = products.filter(function (p) {
          if (!p.published_at) return false;
          return p.variants && p.variants.some(function (v) { return v.available; });
        });
        projectProductsCache[collectionHandle] = products;
        callback(products);
      })
      .catch(function () { callback([]); });
  }

  // Sizes are typed "900mm", "900 mm" or "90cm", but a unit's sizes read
  // "900 / 570" and its SKU "-900-570-", so "900mm" matched nothing and the
  // tab came up empty (Sales Only bugs row 31). Sizes become plain mm.
  function searchWords(term) {
    return term.toLowerCase()
      .replace(/(\d+(?:\.\d+)?)\s*cm\b/g, function (m, n) { return String(Math.round(parseFloat(n) * 10)); })
      .replace(/(\d+)\s*mm\b/g, '$1')
      .split(/\s+/).filter(Boolean);
  }

  function filterProjectProducts(products, term) {
    var words = searchWords(term);
    var results = [];

    products.forEach(function (p) {
      var productText = [p.title, p.handle, p.product_type].join(' ').toLowerCase();
      if (words.every(function (w) { return productText.indexOf(w) !== -1; })) {
        results.push({ product: p, variantId: null });
        return;
      }
      if (p.variants) {
        var matched = null;
        p.variants.some(function (v) {
          var vt = [p.title, p.handle, p.product_type, v.title, v.sku].join(' ').toLowerCase();
          if (words.every(function (w) { return vt.indexOf(w) !== -1; })) {
            matched = v;
            return true;
          }
        });
        if (matched) results.push({ product: p, variantId: matched.id });
      }
    });

    return results.slice(0, 5);
  }

  // ── AJAX tab: preprocessResults ───────────────────────────────────────────
  //
  // Called by predictive-search.js BEFORE innerHTML is set.
  // If a kitchen context exists, injects the My Project tab button and an
  // empty panel into the markup string so that tabbed-content's constructor
  // picks them up as genuine tabs when it initialises.
  //
  // Key timing: tabbed-content captures its NodeList in its constructor.
  // Because predictive-search.js destroys and recreates the entire
  // tabbed-content element on each search, the constructor fires fresh every
  // time. We just need our tab/panel to be present in the HTML string before
  // it is written to innerHTML - which this hook guarantees.

  function preprocessResults(markup, term) {
    // Door swatches are no longer inlined on every page (see
    // btk-style-swatches.js). Kick the fetch off HERE rather than at load:
    // this runs only once the customer actually searches, which is the whole
    // point of moving them off the header. The first keystroke may render
    // without a colour chip; it is cached from then on, and every reader
    // already degrades to no swatch rather than breaking.
    if (window.BTKStyleSwatchesReady) window.BTKStyleSwatchesReady();
    var ctx = readContext();
    if (!ctx) return markup;

    var styleData = window.BTKStyleData || {};
    var styleMeta = styleData[ctx.style];
    if (!styleMeta || !styleMeta.collectionHandle) return markup;

    var parser = new DOMParser();
    var doc = parser.parseFromString(markup, 'text/html');

    // Only inject when Homestead rendered at least one tab (i.e. there are results).
    // If there are no results the tablist element won't be present.
    var tablist = doc.querySelector('[role="tablist"]');
    if (!tablist) return markup;

    // ── Deactivate all existing Homestead tabs & panels ───────────────────
    // Our tab becomes the active first tab.

    doc.querySelectorAll('[role="tab"]').forEach(function (tab) {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });

    doc.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      panel.setAttribute('hidden', '');
    });

    // ── Build My Project tab button ───────────────────────────────────────
    // Uses the same classes as Homestead's predictive-search-tab-button
    // snippet so it inherits all existing tab styling automatically.

    var tabBtn = doc.createElement('button');
    tabBtn.type = 'button';
    tabBtn.className = 'tablist__tab font-bold';
    tabBtn.id = 'btk-project-tab';
    tabBtn.setAttribute('role', 'tab');
    tabBtn.setAttribute('aria-controls', 'btk-project');
    tabBtn.setAttribute('aria-selected', 'true');
    // Active tab must NOT have tabindex="-1"

    var swatchStack = buildSwatchStack(doc, 16);
    if (swatchStack) tabBtn.appendChild(swatchStack);
    tabBtn.appendChild(doc.createTextNode('Buying Style'));

    tablist.insertBefore(tabBtn, tablist.firstChild);

    // ── Build My Project panel ────────────────────────────────────────────
    // Uses the same classes as Homestead's predictive-search-tab-panel snippet.
    // Content is a loading placeholder - onResultsRendered replaces this.

    var panel = doc.createElement('div');
    panel.className = 'predictive-search__tabpanel focus-inset';
    panel.id = 'btk-project';
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('tabindex', '0');
    panel.setAttribute('aria-labelledby', 'btk-project-tab');
    // NOT hidden - this is the active panel

    var loadingDiv = doc.createElement('div');
    loadingDiv.className = 'btk-project-panel__loading';
    loadingDiv.textContent = 'Loading\u2026';
    panel.appendChild(loadingDiv);

    // Insert before the first existing panel inside tabbed-content
    var tabbedContent = doc.querySelector('tabbed-content');
    if (tabbedContent) {
      var firstPanel = tabbedContent.querySelector('[role="tabpanel"]');
      if (firstPanel) {
        tabbedContent.insertBefore(panel, firstPanel);
      } else {
        tabbedContent.appendChild(panel);
      }
    }

    return doc.body.innerHTML;
  }

  // ── AJAX tab: onResultsRendered ───────────────────────────────────────────
  //
  // Called by predictive-search.js AFTER innerHTML is set and tabbed-content
  // has constructed. Fetches and renders My Project results into the panel.

  function onResultsRendered(resultsEl, term) {
    var panel = resultsEl.querySelector('#btk-project');
    if (!panel) return;

    var ctx = readContext();
    if (!ctx) return;

    var styleData = window.BTKStyleData || {};
    var styleMeta = styleData[ctx.style];
    var collectionHandle = styleMeta && styleMeta.collectionHandle;
    if (!collectionHandle) return;

    fetchProjectProducts(collectionHandle, function (products) {
      var filtered = filterProjectProducts(products, term);

      panel.innerHTML = '';

      if (!filtered.length) {
        var tablist = resultsEl.querySelector('[role="tablist"]');
        var firstHomesteadTab = tablist && tablist.querySelector('[role="tab"]:not(#btk-project-tab)');
        if (firstHomesteadTab) firstHomesteadTab.click();
        var emptyMsg = document.createElement('p');
        emptyMsg.className = 'btk-project-panel__empty';
        emptyMsg.textContent = 'No results in your project for \u201c' + term + '\u201d.';
        panel.appendChild(emptyMsg);
        return;
      }

      var ul = document.createElement('ul');
      ul.className = 'predictive-search__list';
      ul.setAttribute('role', 'list');

      filtered.forEach(function (result) {
        var p = result.product;
        var variantId = result.variantId;
        var img = p.images && p.images[0];
        var variant = variantId
          ? p.variants.find(function (v) { return v.id === variantId; })
          : preferredVariant(p);
        var price = variant ? parseFloat(variant.price).toFixed(2) : null;   // products.json prices are pounds ("244.02"), not pence
        var variantTitle = variantId && variant && variant.title !== 'Default Title' ? variant.title : null;
        var url = '/products/' + p.handle + (variantId ? '?variant=' + variantId : '');
        var imgSrc = img ? img.src.replace(/(\.[^.]+)$/, '_112x112$1') : null;

        var li = document.createElement('li');
        li.className = 'predictive-search__item';
        li.setAttribute('role', 'option');

        // Kitchen units have no product photo: the row carries the basket's
        // 3D-picture hooks (btk-cabinet-thumbnail-line-items.js, loaded when
        // the search box is first used), as the Products tab rows do, drawn
        // at the size found in the shopper's own door / carcase colours.
        var isUnit = !imgSrc && variant;
        if (isUnit) {
          li.setAttribute('data-btk-thumb-line', '');
          li.setAttribute('data-btk-thumb-variant-id', String(variant.id));
          li.setAttribute('data-btk-thumb-title', p.title);
          li.setAttribute('data-btk-thumb-style-handle', ctx.style || '');
          li.setAttribute('data-btk-thumb-door-handle', ctx.colour || '');
          li.setAttribute('data-btk-thumb-carcase-handle', ctx.carcase || '');
        }

        li.innerHTML = '<a class="predictive-result flex items-start focus-inset js-search-link" href="' + url + '">'
          + (imgSrc
            ? '<div class="predictive-result__media media relative"><img src="' + imgSrc + '" width="56" height="56" loading="eager" alt=""></div>'
            : '<div class="predictive-result__media media relative">'
              + (isUnit ? '<div class="predictive-result__media" data-btk-thumb-target></div>' : '') + '</div>')
          + '<div class="predictive-result__info flex-auto">'
          + '<h3 class="predictive-result__title h6">' + p.title + '</h3>'
          + (variantTitle ? '<div class="predictive-result__sub-title text-sm">' + variantTitle + '</div>' : '')
          + (price ? '<div class="predictive-result__sub-title text-sm">&pound;' + price + '</div>' : '')
          + '</div></a>';

        ul.appendChild(li);
      });

      // View all - navigates to full results page showing both sections
      var viewAllLi = document.createElement('li');
      viewAllLi.className = 'predictive-search__item js-submit';
      viewAllLi.setAttribute('role', 'option');
      var viewAllBtn = document.createElement('button');
      viewAllBtn.type = 'button';
      viewAllBtn.className = 'predictive-search__view-all link w-full text-start focus-inset has-ltr-icon js-search-link';
      viewAllBtn.innerHTML = 'View all search results<svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M4.696 12h14.686m-7.007-7.5 7.5 7.5-7.5 7.5"></path></svg>';
      viewAllBtn.addEventListener('click', function () {
        window.location.href = '/search?q=' + encodeURIComponent(term);
      });
      viewAllLi.appendChild(viewAllBtn);
      ul.appendChild(viewAllLi);

      panel.appendChild(ul);
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    // No DOM injection needed - all search UI is handled by Homestead.
    // Context is kept fresh from the cart; preprocessResults and
    // onResultsRendered are invoked by hooks in predictive-search.js.
  }

  function refresh() {
    readContextFromCart();
  }

  document.addEventListener('DOMContentLoaded', function () {
    readContextFromCart();
  });

  return {
    init: init,
    refresh: refresh,
    preprocessResults: preprocessResults,
    onResultsRendered: onResultsRendered
  };

})();